import { createModal } from './upvcModal.js'

const showModalHandler = (modelId, modalDivId, jsonFile, inputMessageObj) => {
    const modalBodySection = document.querySelector(`#${modelId}`)
    createModal(modalBodySection, modalDivId, jsonFile, inputMessageObj)
}

const hideModalHandler = (modelId, modalDivId) => {
    const modalBodySection = document.querySelector(`#${modelId}`)
    const modalStart = modalBodySection.querySelector(`#${modalDivId}`)
    if (modalStart)  modalBodySection.removeChild(modalStart)
}

export { showModalHandler, hideModalHandler }